
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Punelocalbusonrent() {



    const cardData =
    {
        keyword: 'Pune Local Bus on Rent',
        heading: 'Amruta Travels: Pune Local Bus on Rent',
        headingDescription: 'Amruta Travels offers Pune Local Bus on Rent, delivering convenient and affordable transportation solutions within the city for events, group outings, corporate transfers, and school trips. Whether you need a bus for a day tour, wedding function, or employee shuttle, our clean and well-maintained fleet ensures a smooth and comfortable ride across Pune. Choose from our range of 17-seater, 32-seater, and 50-seater buses, driven by professional and courteous drivers. With flexible booking options, punctual service, and 24/7 support, Amruta Travels makes local travel in Pune simple, efficient, and stress-free. Book your local bus in Pune today!',


        top: 'Top Places to Visit in Pune with Amruta Travels',
"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],



 "services": [
    {
      "name": "Bus Rental in Pune",
      "description": "Amruta Travels offers a wide range of bus rental options in Pune, including 32, 35, 40, 45, and 50-seater buses. Whether you're planning a local trip or an outstation journey, our well-maintained fleet ensures a comfortable and safe ride with experienced drivers for groups of all sizes."
    },
    {
      "name": "Bus Hire in Pune",
      "description": "Looking for a bus rental in Pune? Amruta Travels provides buses for all occasions, from corporate events to school picnics. Choose from a variety of sizes and amenities to suit your needs, ensuring a smooth and enjoyable trip for all passengers."
    },
    {
      "name": "32, 35, 40, 45, 50 Seater Buses",
      "description": "We offer a range of buses from 32 to 50 seats for group travel. Our buses are equipped with comfortable seating, AC, and modern facilities, making them perfect for both short and long-distance travel."
    },
    {
      "name": "Pune Darshan Tempo Traveller on Rent",
      "description": "Discover Pune with Amruta Travels' tempo traveller rentals. Ideal for group tours, our spacious and air-conditioned tempo travellers ensure a comfortable and convenient city tour to explore Pune's key attractions."
    },
    {
      "name": "Pune to Sinhagad Fort Mini Bus on Rent",
      "description": "Book a mini bus for a scenic trip from Pune to Sinhagad Fort. Our buses provide a comfortable ride for groups visiting this historic fort, offering an enjoyable journey with professional drivers for a safe experience."
    },
    {
      "name": "Pune to Jejuri Bus Hire",
      "description": "Amruta Travels offers bus rental services for groups traveling from Pune to Jejuri, the famous pilgrimage town. Our buses come with AC options, ample space, and skilled drivers, ensuring a smooth trip to this religious destination."
    },
    {
      "name": "Pune to Ranjangaon Ganpati Bus Hire",
      "description": "Book a bus from Pune to Ranjangaon Ganpati for a spiritual journey to one of the Ashta Vinayak temples. Our buses are designed for comfort and safety, making it the perfect choice for group darshan trips."
    },
    {
      "name": "Bus Hire in Pune",
      "description": "Looking for a hassle-free bus rental service in Pune? Amruta Travels offers buses of various sizes for local and outstation travel, ensuring punctuality, comfort, and reliable service for all kinds of group travel."
    },
    {
      "name": "Pune to Ketkawale Balaji Temple Bus on Rent",
      "description": "Visit the revered Ketkawale Balaji Temple from Pune with Amruta Travels. Our bus rental service provides a comfortable journey with experienced drivers for an enriching spiritual experience."
    },
    {
      "name": "Pune to Narayanpur Tempo Traveller on Rent",
      "description": "Book a tempo traveller for a trip to Narayanpur, known for its peaceful ambiance and scenic views. Amruta Travels offers AC tempo travellers with comfortable seating for small to medium-sized groups."
    },
    {
      "name": "Pune to Morachi Chincholi Bus on Rent",
      "description": "Plan a trip to Morachi Chincholi, a serene village famous for peacock sightings, with Amruta Travels' bus rentals. We provide a comfortable ride with experienced drivers for a relaxing getaway from Pune."
    }
  ],
  "tableData": [
    ["Bus Rental in Pune", "Bus Hire in Pune"],
    ["32, 35, 40, 45, 50 Seater Buses", "Pune Darshan Tempo Traveller on Rent"],
    ["Pune to Sinhagad Fort Mini Bus on Rent", "Pune to Jejuri Bus Hire"],
    ["Pune to Ranjangaon Ganpati Bus Hire", "Bus Hire in Pune"],
    ["Pune to Ketkawale Balaji Temple Bus on Rent", "Pune to Narayanpur Tempo Traveller on Rent"],
    ["Pune to Morachi Chincholi Bus on Rent", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Convenient and Comfortable Travel Within Pune",
    "WhyChoosedescription": "Amruta Travels offers Pune Local Bus on Rent, designed to provide a comfortable and convenient mode of transport within Pune. Whether you're planning a local tour, a school trip, a corporate outing, or attending an event, our buses ensure that your travel within the city is smooth, relaxed, and enjoyable. With spacious seating, air conditioning, and modern amenities, we prioritize comfort for all passengers during local trips across Pune."
  },
  {
    "WhyChooseheading": "Ideal for School Trips, Corporate Outings, and Events",
    "WhyChoosedescription": "Our Pune Local Bus on Rent service is perfect for various local events such as school excursions, corporate outings, weddings, and group tours. Whether you need transport for a small group or a larger group, we have buses that can accommodate your needs. With plenty of room for everyone and their belongings, our buses ensure that everyone in your group can travel together comfortably and without hassle."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Safe and Punctual Travel",
    "WhyChoosedescription": "Your safety and punctuality are our top priorities. Our experienced and professional drivers are familiar with the local routes and traffic patterns in Pune, ensuring timely and smooth journeys. Whether you need to attend a meeting, reach an event, or explore local attractions, our drivers ensure that your travel is safe, reliable, and on schedule."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing for Local Travel",
    "WhyChoosedescription": "Amruta Travels offers affordable pricing for Pune Local Bus on Rent. We believe in transparency, so there are no hidden charges or surprises. Our competitive and budget-friendly rates make it easy to plan your local travel, whether for a short trip or an extended excursion. You can trust us to provide high-quality service at the best possible price, with no hidden costs."
  },
  {
    "WhyChooseheading": "Well-Maintained and Clean Buses for Every Journey",
    "WhyChoosedescription": "Our fleet of buses is regularly cleaned, maintained, and inspected to meet high standards of hygiene and safety. Each bus is designed to provide a clean and comfortable environment for passengers, ensuring that your local trip around Pune is enjoyable. We maintain all of our buses with the utmost care, ensuring that everything from the seats to the air conditioning is working perfectly for a smooth ride."
  },
  {
    "WhyChooseheading": "Flexible Pickup and Drop-off Locations Across Pune",
    "WhyChoosedescription": "We offer flexible pickup and drop-off locations throughout Pune to ensure maximum convenience for your group. Whether you need to be picked up from your home, office, hotel, or any other specific location within Pune, we are happy to accommodate your requirements. Additionally, we provide timely drop-offs at your chosen locations to ensure a hassle-free experience for all passengers."
  },
  {
    "WhyChooseheading": "Customizable Itineraries to Suit Your Local Travel Plans",
    "WhyChoosedescription": "We understand that each group has its own unique needs. That’s why we offer customizable itineraries for your local trips in Pune. Whether you need to visit multiple locations, take detours for sightseeing, or extend your trip for additional stops, we can tailor the journey according to your preferences. Our team will work with you to ensure your itinerary is designed to match your specific needs."
  },
  {
    "WhyChooseheading": "Easy Booking Process and Dedicated Customer Support",
    "WhyChoosedescription": "Booking your Pune Local Bus on Rent with Amruta Travels is quick and simple. You can book online, contact our customer service team for assistance, or visit our office. Our dedicated support staff is here to help you with every step of the process, from choosing the right bus to finalizing the itinerary, ensuring that everything is in place for your local trip in Pune."
  }
]





























    }

const faqData = [
  {
    question: 'How can I rent a local bus in Pune?',
    answer: 'Renting a local bus in Pune with Amruta Travels is easy. You can book online, call our support team, or visit our office. We’ll assist you in selecting the right bus based on your group size and specific local travel needs.',
  },
  {
    question: 'What types of buses are available for local rentals in Pune?',
    answer: 'We offer a range of buses for local travel within Pune, including 32, 35, 45, and 50-seater options. Whether you need a standard or luxury bus, we have a vehicle suitable for your requirements.',
  },
  {
    question: 'Can I rent a bus for local sightseeing within Pune?',
    answer: 'Yes, we offer buses for local sightseeing tours within Pune. Whether you want to visit historical landmarks, temples, or enjoy a city tour, our buses are perfect for all types of local excursions.',
  },
  {
    question: 'How much does it cost to rent a bus for local travel in Pune?',
    answer: 'The cost of renting a bus for local travel in Pune depends on factors such as bus size, duration of use, and any additional services required. Please contact us with your trip details for a customized and transparent quote.',
  },
  {
    question: 'Can I rent a bus for corporate events or meetings within Pune?',
    answer: 'Yes, we offer buses for corporate events, meetings, and transportation services within Pune. We can arrange a comfortable and professional ride for your employees or clients, ensuring a smooth travel experience.',
  },
  {
    question: 'Are the buses comfortable for local travel within Pune?',
    answer: 'Yes, all our buses are well-maintained and equipped with comfortable seating, air conditioning, and ample space. Whether it’s for a short trip or a day-long journey, we ensure a comfortable ride throughout.',
  },
  {
    question: 'Do you provide both standard and luxury buses for local rentals in Pune?',
    answer: 'Yes, we provide both standard and luxury buses. Our luxury buses come with added amenities such as premium seating, entertainment options, and air conditioning, ensuring a comfortable and premium travel experience.',
  },
  {
    question: 'Can I request specific pickup and drop-off locations for local trips?',
    answer: 'Yes, we offer flexible pickup and drop-off options. You can share your preferred locations, and we’ll plan the best route for your local travel in Pune.',
  },
  {
    question: 'Why should I choose Amruta Travels for local bus rentals in Pune?',
    answer: 'Amruta Travels is known for offering reliable, comfortable, and punctual bus rental services in Pune. Our well-maintained buses, professional drivers, and commitment to customer satisfaction ensure a smooth and hassle-free local travel experience.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Shankar Jadhav',
    role: 'Event Coordinator, Pune',
    text: 'We rented a 45-seater bus from Amruta Travels for a local event in Pune. The bus was comfortable, well-maintained, and the driver was very professional. Our guests had a great experience, and I will definitely book with Amruta Travels again!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Shetty',
    role: 'Family Trip Organizer, Pune',
    text: 'I rented a 35-seater bus for a family trip within Pune. The bus was perfect for our group, and the journey was comfortable. The driver was very friendly and made the experience enjoyable. Highly recommended for local trips!',
    rating: 5,
  },
];


















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Local Bus on Rent",
  "image": "https://bushireinpune.com/assets/images/pune-local-bus-on-rent.jpg",
  "description": "Rent buses and Tempo Travellers for local travel in Pune. Choose from 32, 35, 40, 45, and 50 seater buses for Pune Darshan, Sinhagad Fort, Jejuri, Ranjangaon Ganpati, Ketkawale Balaji Temple, Narayanpur, and Morachi Chincholi trips. Comfortable and affordable local bus hire with Amruta Travels.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6120"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2999",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/pune-local-bus-on-rent"
  }
};






    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Pune Local Bus on Rent | Darshan & Temple Trip Bus Hire | Amruta Travels</title>
  <meta 
    name="description" 
    content="Book local bus rental in Pune for Pune Darshan, Sinhagad, Jejuri, Ranjangaon Ganpati, Narayanpur, Balaji Temple & Morachi Chincholi. 32 to 50 seater options available with Amruta Travels." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/35.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punelocalbusonrent;